import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { HiringRequestScorecard } from '../../../../../../types';
import { createHiringRequestReference } from './queries';
import { ReferenceToSubmit } from '../../AddContact/types';

export interface CreateReferenceMutationVariables {
  payload: ReferenceToSubmit | FormData;
}

export type HiringRequestReference = HiringRequestScorecard;

export function useCreateHiringRequestReference(
  options?: Omit<
    UseMutationOptions<
      HiringRequestReference,
      AxiosError,
      CreateReferenceMutationVariables,
      unknown
    >,
    'mutationFn'
  >
): UseMutationResult<
  HiringRequestReference,
  AxiosError,
  CreateReferenceMutationVariables,
  unknown
> {
  return useMutation({
    mutationFn: ({ payload }) => createHiringRequestReference(payload),
    ...options,
    onSuccess: (data, variables, context) => {
      options.onSuccess?.(data, variables, context);
    },
  });
}
